import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {Col, Grid, Row} from 'react-bootstrap';
import PageTitle from '../../common/page-title/index';
import ContactForm from './contact-us-form';
import {getContact, sendMessage} from '../../../actions/contact-us';

const CONTACT_MODEL = 'deep.contact_us_team';

class ContactUsPage extends Component {
  onSubmit = (payLoad) => {
    const {dispatch} = this.props;
    dispatch(actions.submitFields(CONTACT_MODEL, sendMessage(payLoad)))
      .then(() => {
        dispatch(actions.reset(`${CONTACT_MODEL}.message`));
      });
  };

  componentWillMount() {
    const {dispatch} = this.props;
    getContact()
      .then((formData) => {
        Object.keys(formData)
          .forEach((field) => {
            const model = `${CONTACT_MODEL}.${field}`;
            dispatch(actions.change(model, formData[field]));
          });
      });
  }

  render() {
    return (
      <Grid bsClass="container" className="contact-us" fluid>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Contact us
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ContactForm
              model={CONTACT_MODEL}
              onSubmit={this.onSubmit}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.viewConfig.profile.attributes,
});

export default connect(mapStateToProps)(ContactUsPage);




// WEBPACK FOOTER //
// ./src/components/team/contact-us/contact-us-page.jsx